import React from 'react'

function CaseNotesPage() {
    return (
        <div>
            Case Notes Page
        </div>
    )
}

export default CaseNotesPage
